import { Controller } from '@hotwired/stimulus';
/**
 * Description
 * -------
 *
 * Handles profile form.
 * Can be used on any element.
 * Should be use only once in the document.
 *
 * Targets
 * -------
 *
 * avatarContainer    - (required) - avatar container element
 * avatarField        - (required) - file input to upload avatar
 * removeAvatarField  - (required) - hidden field to track if avatar is removed
 * removeAvatarButton - (required) - button to remove avatar
 * emailField         - (required) - field to enter email
 * submitModal        - (required) - modal to confirm password
 *
 * Values
 * -------
 *
 * maxFileSize           - (required) - maximum avatar file size in bytes
 * avatarPlaceholderHtml - (required) - HTML for avatar placeholder
 * email                 - (required) - email value
 *
 * Usage
 * -------
 *
 * <div data-controller="profile-form">
 *   <div data-profile-form-target="avatarContainer">
 *     <img src="..." />
 *   </div>
 *
 *   <input type="file" data-profile-form-target="avatarField" data-action="profile-form#setAvatar" />
 *
 *   <input type="hidden" data-profile-form-target="removeAvatarField" />
 *
 *   <button  data-profile-form-target="removeAvatarButton" data-action="profile-form#removeAvatar">
 *     Remove avatar
 *   </button>
 *
 *   <input type="email" data-profile-form-target="emailField" />
 *
 *   <div data-profile-form-target="submitModal">{...}</div>
 * </div>
 */
export default class default_1 extends Controller {
    static targets = [
        'avatarContainer',
        'avatarField',
        'removeAvatarField',
        'removeAvatarButton',
        'emailField',
        'submitModal',
    ];
    static values = {
        maxFileSize: Number,
        avatarPlaceholderHtml: String,
        email: String,
    };
    removeAvatar() {
        this.avatarContainerTarget.innerHTML = this.avatarPlaceholderHtmlValue;
        this.avatarFieldTarget.value = '';
        this.removeAvatarFieldTarget.value = '1';
        this.removeAvatarButtonTarget.classList.add('hidden');
    }
    setAvatar(event) {
        if (!(event.target instanceof HTMLInputElement))
            return;
        if (!(event.target.files && this.validateFile(event.target)))
            return;
        const isValid = this.validateFile(event.target);
        if (!isValid)
            return;
        this.avatarContainerTarget.innerHTML = `<img src=${URL.createObjectURL(event.target.files[0])} class="avatar avatar--xlarge" />`;
        this.removeAvatarButtonTarget.classList.remove('hidden');
    }
    validateFile(inputFile) {
        const file = inputFile.files?.[0];
        let isValid = true;
        if (file && file.size > this.maxFileSizeValue) {
            isValid = false;
            window.alert('This file exceeds the maximum allowed file size (5 MB)');
            inputFile.value = '';
        }
        return isValid;
    }
    submit(event) {
        if (this.emailFieldTarget.value !== this.emailValue) {
            event.preventDefault();
            event.stopPropagation();
            this.submitModalTarget.classList.remove('hidden');
        }
    }
}
